import { useRef } from 'react'

import { v4 as uuidv4 } from 'uuid'

export function useId(): string {
  const id = useRef(uuidv4()).current
  return id
}
